import { Row, Col, Typography, theme } from 'antd'
import PropTypes from 'prop-types'
import { useTranslations } from 'hooks'
import { Icon } from '@qonsoll/icons'

const { Text } = Typography

const RatingAndIdentifyDetails = (props) => {
  const { isVerified, bio } = props

  const { colorPrimary } = theme.useToken().token
  const { t } = useTranslations()

  return (
    <Row gutter={16} className={bio && 'mb-16'}>
      {/* <Col>
        <Rate value={4.1} />  temporary mocked 
      </Col> */}
      {isVerified && (
        <Col className="flex align-center gap-4">
          <Icon name="CheckVerified2Filled" size={18} fill={colorPrimary} />
          <Text className="word-break-init">{t('Identity verified')}</Text>
        </Col>
      )}
    </Row>
  )
}

RatingAndIdentifyDetails.propTypes = {
  isVerified: PropTypes.bool,
  bio: PropTypes.string
}

export default RatingAndIdentifyDetails
